export enum EInputsOrderApiUrl {
  orders = '/api/orders',
  addImpersonalOrder = '/api/orders/:orderId/items',
  expansionOrder = '/api/expansion/order',
  stores = '/api/orders/:id/stores',
  getCodeForSign = '/api/:entityType/:orderId/sign/code',
  signDocument = '/api/:entityType/:orderId/sign',
}
